module.exports = __webpack_public_path__ + "static/NetSup_Verizon-410870ee9dd2ecdec7929db1da89ea92.jpg";